export const PARTNER_ID = 1990;
export const ADMINISTRATOR_ID = 1;
export const MODERATOR_ID = 1500;

export const HEALTHUNLOCKED = 'HealthUnlocked';
export const PARTNER = 'Partner';
export const ADMINISTRATOR = 'Administrator';
export const MODERATOR = 'Moderator';

export const communityAdminRoles = [PARTNER, ADMINISTRATOR, MODERATOR];
export const communityAdminRoleIds = [PARTNER_ID, ADMINISTRATOR_ID, MODERATOR_ID];
